import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { environment } from '../environments/environment';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { Rekbot } from '../models/rekbot.model';
import { RekbotSettings } from '../models/rekbot-settings.model';
import { RekbotStatusAssets } from '../models/rekbot-status-assets';

@Injectable({
  providedIn: 'root',
})
export class RekbotsService {
  //private filteredRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();
  private filteredRekbots: Rekbot[] = [];
  private filteredRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();

  private rekbotsList: Rekbot[] = [];
  private rekbot: Rekbot = new Rekbot(0, '', '', 8080, '', 0, 0, 0);

  public selectedMapRekbot: any = {};

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router
  ) {}

  private mapStatusView(status: number): RekbotStatusAssets {
    switch (status) {
      case 0:
        return {
          label: 'OFFLINE',
          color: 'orange',
          icon: 'assets/img/map_pin_status_OFFLINE.svg',
        };
      case 1:
        return {
          label: 'AWARIA',
          color: 'red',
          icon: 'assets/img/map_pin_status_ERROR.svg',
        };
      case 2:
        return {
          label: 'INFO',
          color: 'blue',
          icon: 'assets/img/map_pin_status_INFO.svg',
        };
      case 10:
        return {
          label: 'OK',
          color: 'green',
          icon: 'assets/img/map_pin_status_OK.svg',
        };

      default:
        return {
          label: 'NIEZNANY STATUS (IN PROGRESS)',
          color: 'white',
          icon: 'assets/img/map_pin_status_UNKNOWN.svg',
        };
    }
  }

  getRekbotStatusAsset(rekbotStatus: number) {
    return this.mapStatusView(rekbotStatus);
  }

  getFilteredRekbots() {
    return this.filteredRekbots;
    //return this.filteredRekbots$;
  }

  setFilteredRekbots(rekbots: Rekbot[] /*rekbots$: Observable<Rekbot[]>*/) {
    //this.filteredRekbots$ = rekbots$;
    this.filteredRekbots = rekbots;
  }

  fetchRekbots() {
    const endpoint = environment.apiUrl + '/api/rekbots';
    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();
    return this.http.get<Rekbot[]>(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    }).pipe(
        map(rekbots => rekbots.map(rekbot => ({
            ...rekbot,
            statusAssets: this.mapStatusView(rekbot.status_new)
        })))
    );
  }

  fetchRekbotSettings(id: number) {
    const endpoint = environment.apiUrl + '/api/rekbots/' + id + '/settings';
    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();
    return this.http.get<RekbotSettings>(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  fetchRekbotSmtp(id: number) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/' + id + '/smtp-settings';

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();
    return this.http.get(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  updateRekbot(rekbot: Rekbot) {
    const endpoint = environment.apiUrl + '/api/rekbots/' + rekbot.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbot, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  updateRekbotSettings(elementId: number, rekbotSetings: RekbotSettings) {
    const endpoint =
      environment.apiUrl +
      '/api/rekbots/' +
      elementId +
      '/settings/' +
      rekbotSetings.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbotSetings, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  createRekbotSettings(elementId: number, rekbotSetings: RekbotSettings) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/' + elementId + '/settings';

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.post(endpoint, rekbotSetings, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  addRekbot(rekbot: Rekbot) {
    const endpoint = environment.apiUrl + '/api/rekbots';

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.post(endpoint, rekbot, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  deleteRekbot(rekbot: Rekbot) {
    const endpoint = environment.apiUrl + '/api/rekbots/' + rekbot.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.delete(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  restartRekbot(rekbot: Rekbot) {
    const endpoint = environment.apiUrl + '/api/rekbots/restart/' + rekbot.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbot, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  restartApplication(rekbot: Rekbot) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/restartApplication/' + rekbot.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbot, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  restartApi(rekbot: Rekbot) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/restartApi/' + rekbot.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbot, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  restartPlc(rekbot: Rekbot) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/restartPlc/' + rekbot.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbot, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  restartPc(rekbot: Rekbot) {
    const endpoint = environment.apiUrl + '/api/rekbots/restartPc/' + rekbot.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbot, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  downloadLogs(rekbot: Rekbot) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/get-log/' + rekbot.serial_no;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();
    return this.http.get(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  fetchRekbot(id: number) {
    const endpoint = environment.apiUrl + '/api/rekbots/' + id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();
    return this.http.get<Rekbot>(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  setRekbot(rekbot: Rekbot) {
    this.rekbot = rekbot;
  }

  getRekbot() {
    return this.rekbot;
  }

  fetchLogFromRekbot(rekbot: Rekbot) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/get-log/' + rekbot.serial_no;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();
    return this.http.get(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  fetchSettingsFromRekbot(rekbotId: number) {
    const endpoint = environment.apiUrl + '/api/rekbots/get-config/' + rekbotId;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();
    return this.http.get(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  fetchRekbotLog(rekbot: Rekbot, queryParams: any) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/rekbot/' + rekbot.id + '/get-log';

    //console.log("fetchRekbotLog", queryParams);

    let qParams = new HttpParams()
      .set('page', queryParams.page.toString())
      .set('pageSize', queryParams.size.toString())
      .set('sort', queryParams.sort.toString())
      .set('search', queryParams.search.toString());

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    //console.log("fetchRekbotLog qParams", qParams);

    return this.http.get(endpoint, {
      headers: new HttpHeaders().set(
        'Authorization',
        bearerToken
      ) /*.set("Content-Type", 'application/json')*/,
      params: qParams,
    });
  }

  sendSettingsToRekbot(rekbotId: number, rekbotSettings: RekbotSettings) {
    const endpoint = environment.apiUrl + '/api/rekbots/put-config/' + rekbotId;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(endpoint, rekbotSettings, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  sendSmtpSettingsToRekbot(rekbotId: number) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/put-smtp-config/' + rekbotId;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.put(
      endpoint,
      {},
      { headers: new HttpHeaders().set('Authorization', bearerToken) }
    );
  }

  generateStoreAPIKey(rekbotId: number) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/generate-store-api-key/' + rekbotId;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.get(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  clearReceipts(rekbotId: number) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/clear-receipts/' + rekbotId;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.get(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  decodeLocationData(rekbotId: number) {
    const endpoint =
      environment.apiUrl + '/api/rekbots/' + rekbotId + '/decode-location';

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    return this.http.get(endpoint, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }

  changeProductionStatus(rekbotIds: number[], status: number) {
    const endpoint = environment.apiUrl + '/api/rekbots/set-production-status';

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = 'Bearer ' + this.authService.getToken();

    const body = { ids: rekbotIds, production_status: status };

    return this.http.post(endpoint, body, {
      headers: new HttpHeaders().set('Authorization', bearerToken),
    });
  }
}
